export default __webpack_public_path__ + "static/media/Anemia.ecd6d179.svg";